<template>
    <div>
        <a-row>
            <a-col :span="1"/>
            <a-col :span="2">
                事件：
            </a-col>
            <a-col :span="4">
                <a-input v-model.trim="input"/>
            </a-col>
            <a-col :span="1"/>
            <a-col :span="2">
                开始时间：
            </a-col>
            <a-col :span="4">
                <my-date :date-value.sync="startDt" :placeholder="'开始时间'"/>
            </a-col>
            <a-col :span="1"/>
            <a-col :span="2">
                结束时间：
            </a-col>
            <a-col :span="4">
                <my-date :date-value.sync="endDt" :placeholder="'结束时间'"/>
            </a-col>
            <a-col :span="2 ">
                <a-button type="primary" @click="look">
                    查询
                </a-button>
            </a-col>
        </a-row>
        <a-table :columns="columns" :data-source="data.data" bordered :scroll="{y:'65vh'}" :pagination="false" rowKey="id">
            <template slot="createDt" slot-scope="text,row">
                <a style="color: #666666">{{getTime(row.createDt)}}</a>
            </template>
            <template slot="lat" slot-scope="text,row">
                <a style="color: #666666">{{'['+row.lng+','+row.lat+']'}}</a>
            </template>
            <template slot="carDrivers" slot-scope="text,row">
                <a style="color: #666666">{{getDervice(row.carDrivers)}}</a>
            </template>
        </a-table>
        <my-page :data="data" @change="onChange"/>
    </div>
</template>

<script>
    import {queryEvent} from './js/ApiQuery'
    import {getNowDateString} from "../../config/Config";

    const columns = [
        {
            title: '序号',
            dataIndex: 'orderNo',
            key: 'orderNo',
            width: '70px',
            align: 'center',
        },
        {
            title: '事件',
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
        },
        {
            title: '事件信息',
            dataIndex: 'msg',
            key: 'msg',
            ellipsis: true,
        },
        {
            title: '事件级别',
            dataIndex: 'level',
            key: 'level',
            width: '100px',
            ellipsis: true,
        },
        {
            title: '发生时间',
            dataIndex: 'createDt',
            key: 'createDt',
            ellipsis: true,
            scopedSlots: {customRender: 'createDt'},
        },
        {
            title: '发生地点',
            dataIndex: 'lat',
            key: 'lat',
            scopedSlots: {customRender: 'lat'},
        },
        {
            title: '司机',
            dataIndex: 'carDrivers',
            key: 'carDrivers',
            ellipsis: true,
            scopedSlots: {customRender: 'carDrivers'},
        },
        {
            title: '车牌号',
            dataIndex: 'car.carNo',
            key: 'car.carNo',
            width: '100px',
            ellipsis: true,
        },
    ];
    export default {
        data() {
            return {
                columns,
                data: {},
                startDt: getNowDateString(),
                endDt: getNowDateString(),
                input: '',
            }
        },
        methods: {
            getData(parameter) {
                queryEvent(parameter).then(res => {
                    this.data = res.data
                })
            },
            // 查询
            look() {
                let baseDto = {
                    queryStartDate: this.startDt,
                    queryEndDate: this.endDt
                };
                this.getData({baseDto:baseDto,name:this.input});
            },
            // 分页
            onChange(page) {
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                    queryStartDate: this.startDt,
                    queryEndDate: this.endDt
                };
                this.getData({baseDto: baseDto});
            },
            // 页面改时间显示
            getTime(date) {
                return this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
            },
            // 页面改司机显示
            getDervice(list) {
                let str = '';
                if(list){
                    list.forEach(item=>{
                        str = str + item.name + ', '
                    })
                }
                return str
            },
        },
        created() {
            let baseDto = {
                queryStartDate: this.startDt,
                queryEndDate: this.endDt
            };
            this.getData({baseDto:baseDto});
        }
    }
</script>

<style scoped>

</style>
